import { Col, Row } from "react-bootstrap";
import { NFCheckBoxInput } from "../../../Shared/NewForms/NFCheckBoxInput";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { useTranslation } from "react-i18next";

const FIxedAssetDetailAdditional = () => {
  const { t } = useTranslation();
  const leasing = [
    { id: 0, name: "Issued" },
    { id: 1, name: "Accepted" },
    { id: 2, name: "Absent" }
  ];
  return (
    <>
      <Row>
        <Col sm={3}>
          <NFCheckBoxInput title={t("Insured")} fieldName={"insured"} />
        </Col>
      </Row>
      <Row>
        <Col sm={3}>
          <NFCheckBoxInput title={t("GuaranteeIsReceived")} fieldName={"guaranteeIsReceived"} />
        </Col>
      </Row>
      <Row>
        <Col sm={3}>
          <NFLookupInput title={t("Leasing")} fieldName={"leasing"} items={leasing} />
        </Col>
      </Row>
      <Row>
        <Col sm={3}>
          <NFDateInput title={t("LeasingDate")} fieldName={"leasingDate"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>{/* <NFLookupInput title={t("PossessionForm")} fieldName={"possessionForm"} items={test} /> */}</Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Model")} fieldName={"model"} />
        </Col>
      </Row>
      <Row>
        <Col sm={3}>
          <NFDateInput title={t("ProductionBuildDate")} fieldName={"productionBuildDate"} />
        </Col>
      </Row>
    </>
  );
};

export default FIxedAssetDetailAdditional;
